import { useMsal } from "@azure/msal-react";
import { useMsalAuth } from "../authConfig";
import { signOut } from "../api/signOut";
import { ReactNode, useContext, useState } from "react";
import { LoginContext } from "../loginContext";
import { useOrganization } from "../contexts/OrganizationContext";

export const OrganizationAccessBoundary = ({ children }: { children: ReactNode }): JSX.Element => {
    const { instance } = useMsal();
    const [signOutError, setSignOutError] = useState<string | null>(null);
    const { loggedIn } = useContext(LoginContext);
    const { context, loading, error, refresh } = useOrganization();
    const [signingOut, setSigningOut] = useState(false);
    if (!loggedIn) return <>{children}</>;
    if (loading) return <main aria-busy="true">Loading organization access…</main>;
    if (error || context?.state === "no_access") {
        return (
            <main style={{ maxWidth: 560, margin: "15vh auto", padding: 32 }}>
                <h1>{error ? "Unable to load organization access" : "No organization access"}</h1>
                <p>
                    {error ??
                        "Your account is available, but you currently have no accessible organization. Contact your organization administrator to restore access, or use a new invitation to join an organization."}
                </p>
                {signOutError && <p role="alert">{signOutError}</p>}
                <button type="button" onClick={() => void refresh()}>
                    Refresh access
                </button>{" "}
                <button
                    type="button"
                    disabled={signingOut}
                    onClick={() => {
                        setSigningOut(true);
                        setSignOutError(null);
                        void signOut(useMsalAuth ? instance : undefined)
                            .then(() => {
                                window.location.href = "/#/login";
                                window.location.reload();
                            })
                            .catch((caughtError: unknown) => {
                                setSignOutError(caughtError instanceof Error ? caughtError.message : "Sign out failed. Please try again.");
                                setSigningOut(false);
                            });
                    }}
                >
                    Sign out
                </button>
            </main>
        );
    }
    return <>{children}</>;
};
